import React from 'react';
import styles from './WbLoading.module.css';

export const WBLOADING_SIZES = Object.freeze({
  small: 'wbLoadingSmall',
  large: 'wbLoadingLarge',
});

const WbLoading = ({ size }) => (
  <div aria-label="loading" className={`${styles.wbLoading} ${styles[size]}`}></div>
);

WbLoading.defaultProps = {
  size: WBLOADING_SIZES.large,
};

export default WbLoading;
